import { useState, useCallback } from "react"

/**
 * Wraps a text-input value, provides helpers for empty-checking and
 */
export function useInputValue(defaultValue: string, opts?: {
    onBlur?: (value: string) => string
}): [
        /**
         * Current value
         */
        string,

        /**
         * onChange
         */
        (e: React.ChangeEvent<HTMLInputElement>) => void,

        /**
         * onBlur
         */
        (e: React.ChangeEvent<HTMLInputElement>) => void,

        /**
         * Set input manually
         */
        (value: string) => void,
    ] {

    const [state, setState] = useState(defaultValue)

    const setInputState = useCallback((e: React.ChangeEvent<HTMLInputElement>) =>
        setState(e.target.value), [])

    const setStateOnBlur = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.value.trim() === "") {
            setState(defaultValue)
        } else {
            let value = e.target.value.trim()
            value = opts?.onBlur?.(value) ?? value

            setState(value)
        }
    }, [defaultValue, opts])

    const setInputManually = useCallback((value: string) => {
        setState(value)
    }, [])

    return [
        state,
        setInputState,
        setStateOnBlur,
        setInputManually,
    ]
}
